import useKey from './useKey';
const useEsc = (callback) => {
    useKey(event => event.key === 'Escape' && callback(event));
};
export default useEsc;
